import CategoryList from "./CategoryList";
import CategoryCreate from "./CategoryCreate";
import CategoryEdit from "./CategoryEdit";
import CategoryShow from "./CategoryShow";
import CategoryIcon from "@mui/icons-material/Category";

const categories = {
  list: CategoryList,
  create: CategoryCreate,
  edit: CategoryEdit,
  show: CategoryShow,
  icon: CategoryIcon,
};

export default categories;
